/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undefined */
/* eslint-disable no-undef */
ACC.global = {

  _autoload: ['initImager'],

  initImager: function(elems) {
    elems = elems || '.js-responsive-image';
    this.imgr = new Imager(elems);// NOSONAR
  },

  reprocessImages: function(elems) {
    elems = elems || '.js-responsive-image';

    if (this.imgr === undefined) {
      this.initImager(elems);
    } else {
      this.imgr.checkImagesNeedReplacing($(elems));
    }
  },
  isEmptycheckValue: function(inputIdMain) {
    var inputClsVal = $(inputIdMain).val(),
        inputupCls = $(inputIdMain).parent();

    if (inputClsVal === '' || inputClsVal === null || inputClsVal === 'undefined') {
      $(inputupCls).find('.ph-email_error').removeClass('hidden');
      $(inputIdMain).addClass('ph-email_err_border');
      $(inputIdMain).next().addClass('ph-email_err_txt');
    } else {
      $(inputupCls).find('.ph-email_error').addClass('hidden');
      $(inputIdMain).removeClass('ph-email_err_border');
      $(inputIdMain).next().removeClass('ph-email_err_txt');
    }
  }
};
$(document).ready(function() {
  var responseImage = 'responsive-image';

  ACC.global.reprocessImages('.js-' + responseImage);

  $(document).on('keyup', '.ph-username', function() {
    var emailAddLogin = $(this).val(),
        emailupCls = $(this).parent();

    ACC.global.isEmptycheckValue(this);

    if (ACC.validation.email(emailAddLogin)) {
      $(emailupCls).find('.ph-email_error').removeClass('hidden');
      $(this).addClass('ph-email_err_border');
      $(this).next().addClass('ph-email_err_txt');
    } else {
      $(emailupCls).find('.ph-email_error').addClass('hidden');
      $(this).removeClass('ph-email_err_border');
      $(this).next().removeClass('ph-email_err_txt');
    }
  });

  $(document).on('keyup', '.ph-pwdinput', function() {
    ACC.global.isEmptycheckValue(this);
  });
  $(document).on('click', '#ph-logindetails', function(event) {
    event.preventDefault();
    $('.form_field-label input').each(function() {
      if ($(this).val() === '') {
        ACC.global.isEmptycheckValue(this);
      }
    });

    if ($('.ph-email_err_border').length > 0) {
      return false;
    }

    $('#loginForm')[0].submit();

    return true;
  });
});
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
/* eslint-enable no-param-reassign */
/* eslint-enable no-undefined */
/* eslint-enable no-undef */
